import React, { useCallback } from 'react'

import { SearchModalRow } from 'conversations/components/SearchModal'
import { useHistory } from 'react-router'

import ConversationSearchResultItem from '../ConversationSearchResultItem'
import { InsightsConversation } from '../SearchModal/api'

interface ShowResultsProps {
  conversations: InsightsConversation[]
  hoveredIndex: number | null
  setHoveredIndex: (index: number) => void
  closeModal: () => void
}

const ShowResults: React.FC<ShowResultsProps> = ({
  conversations,
  hoveredIndex,
  setHoveredIndex,
  closeModal,
}): JSX.Element => {
  const history = useHistory()

  const onSelectCallback = useCallback(
    (index) => {
      const conversation = conversations[index]
      history.push(`/conversations/${conversation.conversationId}`)
      closeModal()
    },
    [closeModal, history, conversations]
  )

  return (
    <div data-ocweb-id="ShowConversationResults">
      {conversations.map((conversation, index) => {
        const isHovered = hoveredIndex === index

        return (
          <SearchModalRow
            key={conversation.conversationId}
            hovered={isHovered}
            onHover={setHoveredIndex}
            onSelect={onSelectCallback}
            index={index}>
            <ConversationSearchResultItem conversation={conversation} isHovered={isHovered} />
          </SearchModalRow>
        )
      })}
    </div>
  )
}

export default ShowResults
